import CheckboxBase from '@/global/components/Form/Base/Checkbox'
import Grid from '@/global/components/ui/Grid'
import { FormField } from 'global/components/Form'
import IconeAjuda from 'global/components/IconeAjuda'
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'

const mensagemDefault = `Parabéns pelo seu aniversário! 🎉🎈🎂 
Aproveite seu dia ao máximo, com risadas, diversão e, quem sabe, 
um cochilo de leve depois do almoço. 😴`

export default function OutrosDados() {
    const { watch, setValue } = useFormContext()
    const mensagem = watch('mensagemAniversario')

    const [enviarMensagem, setEnviarMensagem] = useState(!!mensagem)

    return (
        <section id="dados-cadastrais">
            <Grid container spacing={2}>
                <Grid item xs={12} className="flex flex-row items-center">
                    <CheckboxBase
                        checked={enviarMensagem}
                        onChange={() =>
                            setEnviarMensagem(prev => {
                                if (!prev) {
                                    setValue(
                                        'mensagemAniversario',
                                        mensagemDefault,
                                    )
                                    return true
                                }
                                setValue('mensagemAniversario', '')
                                return false
                            })
                        }
                    >
                        Enviar notificação no aniversário de cada colaborador
                        <IconeAjuda>
                            <p>
                                Ao ativar essa opção, será enviada uma mensagem
                                de parabéns no aniversário de cada colaborador.
                            </p>
                            <p>A notificação será exibida no aplicativo.</p>
                        </IconeAjuda>
                    </CheckboxBase>
                </Grid>
                <Grid item xs={12}>
                    <FormField
                        name="mensagemAniversario"
                        label="Mensagem"
                        rows={5}
                        multiline
                        disabled={!enviarMensagem}
                        max={250}
                    />
                </Grid>
            </Grid>
        </section>
    )
}
